"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGridBase = exports.StyledZGridBase = exports.ZGridBaseComponent = void 0;
const React = __importStar(require("react"));
const utils = __importStar(require("./zGridUtils"));
const AppContext_1 = require("../../utils/AppContext");
const customColumnMenu_1 = require("./customColumnMenu");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const ZAlert_1 = require("../ZAlert/ZAlert");
const ll_1 = require("../../languages/ll");
const ZLoadingMask_1 = require("../ZLoadingMask/ZLoadingMask");
const kendo_data_query_1 = require("@progress/kendo-data-query");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const apis_1 = require("../../apis");
const styled_components_1 = __importDefault(require("styled-components"));
class ZGridBaseComponent extends React.Component {
    constructor(props) {
        super(props);
        this.boundDataStateChangeHandler = this.handleDataStateChange.bind(this);
        this.boundColumnStateChangeHandler = this.handleColumnStateChange.bind(this);
        this.boundColumnFilterChangeHandler = this.handleColumnFilterChange.bind(this);
        this.boundColumnSortChangeHandler = this.handleColumnSortChange.bind(this);
        this.boundColumnMenuGenerator = this.columnMenu.bind(this);
        this.boundColumnsSubmitHandler = this.onColumnsSubmit.bind(this);
        this.boundPageChangeHandler = this.handlePageChange.bind(this);
        this.rowRender = (trElement, dataItem) => {
            const trProps = {
                ...trElement.props,
                key: dataItem.Id,
                onDoubleClick: (event) => {
                    this.props.onDoubleClick &&
                        this.props.onDoubleClick(event, dataItem);
                }
            };
            return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
        };
        const { skip, take, sort, columns, pageSize, pageable, handleQuery } = props;
        this.state = {
            skip: pageable ? skip || 0 : undefined,
            take: pageable ? take || pageSize || 10 : undefined,
            sort,
            columns,
            dataResult: {
                data: pageable || handleQuery
                    ? (props.data || []).slice(0, take || pageSize || 10)
                    : props.data || [],
                total: (props.data || []).length
            },
            mask: false,
            initialized: false
        };
        this.containerRef = React.createRef();
        if (this.props.setGridInstance) {
            this.props.setGridInstance(this);
        }
    }
    componentDidMount() {
        if (!this.state.initialized) {
            this.setState({
                initialized: true
            });
            this.getData();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { columns: columnsFromProps } = this.props;
        const { skip, take, sort, filter, mask, columns: columnsFromState } = this.state;
        const { data, handleQuery, queryOnColumnChange, pageable, pending } = this.props;
        if (data &&
            (data != prevProps.data ||
                skip !== prevState.skip ||
                take !== prevState.take ||
                sort !== prevState.sort ||
                filter !== prevState.filter)) {
            const filteredData = kendo_data_query_1.filterBy(data, filter || {
                logic: "and",
                filters: []
            });
            const filteredOrderedData = kendo_data_query_1.orderBy(filteredData, sort || []);
            let newData = filteredOrderedData;
            let newSkip = undefined;
            if (pageable) {
                newData = filteredOrderedData.slice(skip || 0, (skip || 0) + (take || 0));
                if (newData.length === 0 && skip !== 0) {
                    newSkip =
                        filteredOrderedData.length > 0
                            ? (Math.ceil(filteredOrderedData.length / (take || 0)) -
                                1) *
                                (take || 0)
                            : 0;
                    newData = filteredOrderedData.slice(newSkip, newSkip + (take || 0));
                }
            }
            this.setState({
                skip: newSkip !== undefined ? newSkip : skip,
                dataResult: {
                    data: newData,
                    total: filteredOrderedData.length
                }
            });
        }
        else if (handleQuery &&
            (handleQuery !== prevProps.handleQuery ||
                skip !== prevState.skip ||
                take !== prevState.take ||
                sort !== prevState.sort ||
                filter !== prevState.filter ||
                (queryOnColumnChange && columnsFromState !== prevState.columns))) {
            this.getData();
        }
        if (columnsFromProps != prevProps.columns) {
            this.setState({
                columns: columnsFromProps
            });
        }
        if (this.containerRef.current) {
            const noRecords = this.containerRef.current.querySelector(".k-grid-content");
            if (noRecords) {
                if (mask || pending) {
                    noRecords.style.display = "none";
                }
                else {
                    noRecords.style.display = "flex";
                }
            }
        }
    }
    mask() {
        if (!this.state.mask) {
            this.setState({
                mask: true
            });
        }
    }
    unmask() {
        if (this.state.mask) {
            this.setState({
                mask: false
            });
        }
    }
    firstPage() {
        const { skip } = this.state;
        if (skip !== 0) {
            this.setState({
                skip: 0
            });
        }
        else {
            this.getData();
        }
    }
    lastPage() {
        const { dataResult, take, skip } = this.state;
        var newSkip = dataResult.total > 0
            ? (Math.ceil(dataResult.total / (take || 0)) - 1) * (take || 0)
            : 0;
        if (skip !== newSkip) {
            this.setState({
                skip: newSkip
            });
        }
        else {
            this.getData();
        }
    }
    refresh() {
        this.getData();
    }
    export() {
        if (this.axiosInstance && this.props.handleExport) {
            this.setState({
                mask: true
            });
            this.props
                .handleExport(this.axiosInstance, {
                sort: this.state.sort,
                filter: this.state.filter,
                columns: this.state.columns
            })
                .finally(() => {
                this.setState({
                    mask: false
                });
            });
        }
    }
    render() {
        const { ignoreColumns } = this.props;
        const { title, className, handleQuery, pending, localize, ...gridProps } = this.props;
        const { resizable, reorderable, filterable, style, columnVirtualization, pageable, onRowClick, scrollable } = gridProps;
        const { skip, take, sort, filter, columns, dataResult, mask } = this.state;
        const uniqueId = kendo_react_common_1.guid();
        const setAxiosInstance = (axiosInstance) => {
            this.axiosInstance = axiosInstance;
            return true;
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, id: `container-${uniqueId}`, ref: this.containerRef },
                title ? React.createElement("div", { className: "z-grid-title" }, title) : null,
                React.createElement(ll_1.LLConsumer, null, ({ languageId }) => (React.createElement(AppContext_1.AppContext.Consumer, null, ({ apiClient, isMobile }) => setAxiosInstance(apiClient) && (React.createElement(kendo_react_grid_1.Grid, Object.assign({ columnVirtualization: columnVirtualization || false }, gridProps, { data: dataResult, sort: sort, filter: filter, skip: skip, take: take, pageable: typeof pageable === "object"
                        ? {
                            ...pageable,
                            buttonCount: isMobile
                                ? 4
                                : undefined,
                            info: isMobile ? false : true,
                            pageSizes: isMobile
                                ? false
                                : [5, 10, 20, 50, 100]
                        }
                        : pageable === true || handleQuery
                            ? {
                                buttonCount: isMobile
                                    ? 4
                                    : undefined,
                                info: isMobile ? false : true,
                                pageSizes: isMobile
                                    ? false
                                    : [5, 10, 20, 50, 100]
                            }
                            : pageable, onPageChange: this.boundPageChangeHandler, onDataStateChange: this.boundDataStateChangeHandler, onFilterChange: this.boundColumnFilterChangeHandler, onSortChange: this.boundColumnSortChangeHandler, onColumnReorder: this.boundColumnStateChangeHandler, onColumnResize: this.boundColumnStateChangeHandler, onRowClick: event => {
                        this.setState({
                            selectedItemId: event.dataItem.Id,
                            dataResult: {
                                ...dataResult,
                                data: dataResult.data.map(d => ({
                                    ...d,
                                    selected: d.Id === event.dataItem.Id
                                }))
                            }
                        });
                        onRowClick && onRowClick(event);
                    }, style: style || {
                        width: 1200,
                        height: 400
                    }, resizable: resizable || true, reorderable: reorderable || true, scrollable: scrollable || "scrollable", rowHeight: 40, rowRender: (trElement, dataItem) => this.rowRender(trElement, dataItem) }), columns
                    ? columns.map((column, idx) => {
                        let shouldIgnore = false;
                        if (ignoreColumns) {
                            if (ignoreColumns.indexOf(column.field || "") !== -1) {
                                shouldIgnore = true;
                            }
                        }
                        if (shouldIgnore) {
                            return null;
                        }
                        else {
                            return column
                                .hide !== true ? (React.createElement(kendo_react_grid_1.GridColumn, Object.assign({ key: idx, resizable: column.resizable ||
                                    resizable, reorderable: column.reorderable ||
                                    reorderable, columnMenu: this
                                    .boundColumnMenuGenerator, headerClassName: className, className: className, filterable: column.filterable ||
                                    filterable, format: column.format ||
                                    utils.guessFormatForField(column.field), filter: column.filter ||
                                    utils.guessTypeForField(column.field), editor: column.editor ||
                                    utils.guessTypeForField(column.field) }, column, { title: localize == false
                                    ? column.title
                                    : ll_1.ll({
                                        key: column.title ||
                                            column.field ||
                                            "",
                                        languageId
                                    }) }))) : null;
                        }
                    })
                    : null)))))),
            (pending || mask) && (React.createElement(ZLoadingMask_1.ZLoadingMask, { containerSelector: `#container-${uniqueId} .k-grid` }))));
    }
    handleDataStateChange(e) {
        this.setState(e.dataState);
    }
    handleColumnStateChange(e) {
        const newColumns = (this.state.columns || []).map(column => {
            const matchingColumn = e.columns.find(c => c.field === column.field);
            return matchingColumn
                ? {
                    ...matchingColumn,
                    title: column.title
                }
                : column;
        });
        this.setState({
            columns: newColumns
        });
    }
    handleColumnFilterChange(e) {
        this.setState({
            filter: e.filter || undefined
        });
    }
    handleColumnSortChange(e) {
        this.setState({
            sort: e.sort || undefined
        });
    }
    handlePageChange(e) {
        this.setState({
            skip: e.page.skip,
            take: e.page.take
        });
    }
    onColumnsSubmit(columnsState) {
        this.setState({
            columns: columnsState
        });
    }
    columnMenu(props) {
        return (React.createElement(customColumnMenu_1.CustomColumnMenu, Object.assign({ onColumnsSubmit: this.boundColumnsSubmitHandler, columns: this.state.columns, className: this.props.className, ignoreColumns: this.props.ignoreColumns, filterProps: this.props.columnMenuFilterProps }, props)));
    }
    getData() {
        const { skip, take, sort, filter, columns } = this.state;
        const { handleQuery } = this.props;
        if (this.axiosInstance && handleQuery) {
            this.setState({
                mask: true
            });
            handleQuery(this.axiosInstance, {
                skip: skip,
                take: take,
                sort: sort,
                filter: filter,
                columns: columns
            })
                .then(dataResult => {
                if (dataResult) {
                    if (dataResult.data.length > 0 || skip === 0) {
                        this.setState({
                            dataResult: dataResult
                        });
                    }
                    else {
                        this.setState({
                            mask: true,
                            dataResult: dataResult,
                            skip: dataResult.total > 0
                                ? (Math.ceil(dataResult.total / (take || 0)) -
                                    1) *
                                    (take || 0)
                                : 0
                        });
                    }
                }
            })
                .finally(() => {
                this.setState({
                    mask: false
                });
            });
        }
    }
}
exports.ZGridBaseComponent = ZGridBaseComponent;
exports.StyledZGridBase = styled_components_1.default(ZGridBaseComponent) `
   font-family: ${props => props.theme["font-family"]};
   & .k-grid-norecords {
      font-family: ${props => props.theme["font-family"]};
   }
   & .k-filter-row {
      display: none;
   }
   & .k-grid-header[style] {
      padding: 0px !important;
      & .k-header {
         padding: 8px 15px 8px 24px !important;
         background: #f5f5f5;
         font-weight: normal;
         color: ${p => p.theme["banner-background-color"]};
      }
   }
   & .k-grid tr.k-state-selected > td {
      color: ${p => p.theme["action-button-hover-text-color"]};
      background-color: ${p => p.theme["selected-background-color"]};
   }
   & .k-master-row {
      line-height: 18px;
   }
   & .k-grid-pager {
      font-family: ${props => props.theme["font-family"]};
      & a.k-state-selected {
         color: ${p => p.theme["action-button-hover-text-color"]};
         background-color: ${p => p.theme["selected-background-color"]};
      }
   }

   & .z-grid-title {
      font-weight: bold;
      font-family: ${props => props.theme["font-family"]};
      margin: 5px 5px 5px 5px;
   }
   & .k-icon {
      color: ${p => p.theme["app-link-color"]};
      &:hover,
      &:hover::before {
         color: ${p => p.theme["hover-color"]};
      }
      &:active,
      &:active::before {
         color: ${p => p.theme["active-color"]};
      }
   }
   .k-popup & {
      padding: 0px;
   }
   & .k-columnmenu-item,
   & .k-column-list-item,
   & .k-columnmenu-actions {
      background-color: #f5f5f5;
      &:hover,
      &:hover .k-icon {
         background-color: #f5f5f5;
         color: ${p => p.theme["hover-color"]};
      }
      &:active,
      &:active .k-icon {
         color: ${p => p.theme["active-color"]};
      }
      & .k-button {
         background-color: #ebebeb;
         &:hover {
            color: ${p => p.theme["hover-color"]};
         }
         &.k-primary {
            background-color: ${p => p.theme["app-link-color"]};
            &:hover {
               background-color: ${p => p.theme["hover-color"]};
               color: #ebebeb;
            }
            color: #ebebeb;
         }
      }
   }
   .k-loading-mask {
      top: 0 !important;
      left: 0 !important;
   }
`;
exports.ZGridBase = (props) => {
    const appContextValue = React.useContext(AppContext_1.AppContext);
    const apiClient = apis_1.useApiClientWithGroupCorrelationId(appContextValue.apiClient);
    return (React.createElement(ZAlert_1.IssueAlertProvider, null,
        React.createElement(AppContext_1.AppContext.Provider, { value: { ...appContextValue, apiClient } },
            React.createElement(exports.StyledZGridBase, Object.assign({}, props)))));
};
exports.default = exports.ZGridBase;
//# sourceMappingURL=ZGridBase.js.map